/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import OptionCellDropdown from 'notebook/plain-tables/selectors/OptionCellDropdown';
import {Selector} from 'notebook/tables/excess/EvaluationConstants';

interface Props {
  isSelected: boolean;
  locked: boolean;
  isProtected?: boolean;
  selector: Selector;
  onOpenManageSelectorsModal: (...args: Array<any>) => any;
  onOpenDropdown: (...args: Array<any>) => any;
  onUpdate: (...args: Array<any>) => any;
}

/**
 * Icon which allows picking an ELN dropdown option for a cell, or opening a modal to edit the
 * dropdown options.
 */
class SelectorDropdown extends React.Component<Props> {
  _handleOpenSelectorModal = (): void => {
    this.props.onOpenManageSelectorsModal(this.props.selector.staticId);
  };

  override render(): JSX.Element {
    return (
      <OptionCellDropdown
        isSelected={this.props.isSelected}
        locked={this.props.locked}
        menuHeader={<li className="dropdown-header">{this.props.selector.name}</li>}
        menuFooter={
          !this.props.locked &&
          !this.props.isProtected && [
            <li key="divider" className="divider" />,
            <li key="edit-selector">
              <a onClick={this._handleOpenSelectorModal}>{`Edit "${this.props.selector.name}"`}</a>
            </li>,
          ]
        }
        options={this.props.selector.options}
        onOpenDropdown={this.props.onOpenDropdown}
        onUpdate={this.props.onUpdate}
      />
    );
  }
}

export default SelectorDropdown;
